<template>
    <ul :class="{ collapsed: collapsed }">
        <li
            v-for="frequencySet in frequencySets"
            :key="frequencySet.id"
            :title="frequencySet.name"
        >
            <span :data-test-id="`row-${row.id}-frequency-set-${frequencySet.id}-label`">{{ frequencySet.name }}</span>
            <frequency-set-type-badge
                :type="frequencySet.type"
                :data-test-id="`row-${row.id}-frequency-set-${frequencySet.id}-type`"
            />
        </li>
        <li
            v-if="total > collapsedCount"
            class="toggle-display-all"
        >
            <a
                href="#"
                :title="toggleText"
                :data-test-id="`row-${row.id}-frequency-sets-toggle`"
                @click.prevent="toggleFrequencySets()"
                >{{ toggleText }}</a
            >
        </li>
    </ul>
</template>

<script>
import FrequencySetTypeBadge from '@/components/FrequencySetTypeBadge.vue'

// Sync with ArrayTableCell
const COLLAPSED_COUNT = 4

export default {
    name: 'FrequencySetListCell',

    components: {
        FrequencySetTypeBadge,
    },

    props: {
        // A single frequency set an array of them
        items: {
            type: [Array, Object],
            default: null,
        },
        col: {
            type: Object,
            default: () => ({}),
        },
        total: {
            type: Number,
            default: null,
        },
        row: {
            type: Object,
            default: () => ({}),
        },
    },

    emits: ['get-relation-items'],

    data() {
        return {
            collapsed: true,
            collapsedCount: COLLAPSED_COUNT,
        }
    },

    computed: {
        frequencySets() {
            if (!this.items) {
                return []
            }

            const frequencySets = Array.isArray(this.items) ? this.items : [this.items]

            return frequencySets.filter(
                (frequencySet, index) => frequencySets.findIndex(({ id }) => id === frequencySet.id) === index
            )
        },

        toggleText() {
            return this.collapsed ? `Show All (${this.total})` : 'Collapse'
        },
    },

    methods: {
        toggleFrequencySets() {
            // The row only carries the first few; ask the table to fetch the rest before expanding.
            if (this.collapsed && this.total !== this.frequencySets.length) {
                this.$emit('get-relation-items')
            }

            this.collapsed = !this.collapsed
        },
    },
}
</script>

<style scoped>
li {
    display: flex;
    align-items: center;
    gap: 8px;
}

.collapsed li:nth-of-type(n + 5) {
    display: none;
}

.toggle-display-all {
    display: list-item !important;
}
</style>
